import React from 'react';
import { TBookmarkInfo } from './fdr-use-share-links.types';

export enum EShareType {
  FACEBOOK = 'facebook',
  X = 'x',
  WHATSAPP = 'whatsapp',
  MAIL = 'mail',
  DOWNLOAD = 'download',
}

export type TShareLink = {
  name?: string;
  icon: string;
  apiLink: string | undefined;
  func?: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void | undefined;
};
export type TShareLinks = {
  [key in EShareType]?: TShareLink;
};

const NEW_LINE = decodeURIComponent(`%0D%0A`);
const DOUBLE_NEW_LINE = decodeURIComponent(`%0D%0A%0D%0A`);

const CHAR_LIMIT = 2047;

export const getUrlsText = (
  toShare: TBookmarkInfo[],
  textSize: number
): [string, number] => {
  const fullResult = toShare
    .map(({ link, name }) => [name?.trim(), link?.trim()].join(NEW_LINE))
    .join(DOUBLE_NEW_LINE);

  const linkLength = encodeURIComponent(fullResult).length + textSize;

  if (linkLength <= CHAR_LIMIT) return [fullResult, linkLength];

  let result = '';

  for (const { link, name } of toShare) {
    const text = [name?.trim(), link?.trim()].join(NEW_LINE);
    const tmpRes = result ? result + DOUBLE_NEW_LINE + text : text;

    if (encodeURIComponent(tmpRes).length + textSize > CHAR_LIMIT)
      return [result, linkLength];

    result = tmpRes;
  }

  return [result, result.length];
};
